import React from "react"
import { Grid } from "../../atoms/grid"
import styled from "styled-components"
import { Settings } from "../../../styles/theme"

import FB from "../../../images/socialmedias/fb.png"
import LI from "../../../images/socialmedias/linkedin.png"
import TW from "../../../images/socialmedias/twitter.png"
import YT from "../../../images/socialmedias/youtube_solid.png"
import IG from "../../../images/socialmedias/instagram_solid.png"
import FBFooter from "../../../images/socialmedias/fb_white.png"
import LIFooter from "../../../images/socialmedias/linkin_white.png"
import TWFooter from "../../../images/socialmedias/twitter_white.png"
import YTFooter from "../../../images/socialmedias/youtube_logo.png"
import IGFooter from "../../../images/socialmedias/instagram_white.png"

const Socialstyle = styled.div`
  max-width: 360px;
  width: 10%;
  min-width: 100px;
  div,
  svg {
    color: ${Settings.primaryColor};
  }
  div {
    text-align: center;
  }
  img {
    height: 14px;
  }
  .footer {
    height: 24px;
    width: auto !important;
  }
  > div {
    width: ${props => (props.footer ? "140px" : "120px")};
  }
  .li {
    height: 18px !important;
    width: 18px !important;
  }
`

export const Social = ({ footer }) => (
  <Socialstyle footer={footer}>
    <Grid columns={4} unstack>
      <div>
        <a
          href="https://www.facebook.com/OfficialSingaporeAirshow"
          target="_blank"
        >
          <img
            src={footer ? FBFooter : FB}
            className={footer ? "footer fb" : "fb"}
            style={footer ? { height: "32px" } : { height: "auto" }}
          />
        </a>
      </div>
      <div>
        <a
          href="https://www.linkedin.com/company/singapore-airshow/"
          target="_blank"
        >
          <img
            src={footer ? LIFooter : LI}
            className={footer ? "footer li" : " li"}
          />
        </a>
      </div>
      <div>
        <a href="https://twitter.com/sgairshow" target="_blank">
          <img
            src={footer ? TWFooter : TW}
            className={footer ? "footer" : ""}
          />
        </a>
      </div>
      <div>
        <a
          href="https://www.youtube.com/channel/UCDZCcdxLdzD2qQWUi7-ae1A"
          target="_blank"
        >
          <img
            src={footer ? YTFooter : YT}
            className={footer ? "footer" : ""}
          />
        </a>
      </div>
      <div>
        <a
          href="https://www.instagram.com/singaporeairshow/"
          target="_blank"
        >
          <img
            src={footer ? IGFooter : IG}
            className={footer ? "footer" : ""}
          />
        </a>
      </div>
    </Grid>
  </Socialstyle>
)
